import Vue from 'vue';

Vue.component('vuetable-reimbursement', () =>
    import(/* webpackChunkName: 'reimbursement-index' */ './vuetable-reimbursement.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/reimbursement/index.js